//@ts-check
import React from 'react';
/**@type {import('../types').DataType<import('./types').EmailConnectionDataModel>} */

var SEND_EMAIL_CONNECTION_DATA_TYPE = {
  data: {
    url: '/backend/testconnections/sendemail',
    itemUrl: 'backend/testconnections/sendemail',
    dataKey: 'testconnections',
    idKeyProp: 'Name'
  }
};
export default SEND_EMAIL_CONNECTION_DATA_TYPE;